import ReactGA from 'react-ga4';

// Google Analytics measurement ID
const MEASUREMENT_ID = 'G-CQZ1T6WN34'; // Specific tracking ID for this application

let isInitialized = false;
let consentGranted = false;

/**
 * Set analytics consent status
 * @param consent - Whether consent is granted
 */
export const setAnalyticsConsent = (consent: boolean) => {
  consentGranted = consent;
  
  // Update Google's consent mode v2
  if (typeof window !== 'undefined') {
    window.gtag?.('consent', 'update', {
      'ad_storage': consent ? 'granted' : 'denied',
      'analytics_storage': consent ? 'granted' : 'denied',
      'ad_user_data': consent ? 'granted' : 'denied',
      'ad_personalization': consent ? 'granted' : 'denied',
    });
  }
  
  if (consent && !isInitialized) {
    // Initialize ReactGA only if consent is granted and not already initialized
    initGA();
  }
};

/**
 * Initialize Google Analytics
 */
export const initGA = () => {
  if (typeof window !== 'undefined' && !isInitialized) {
    // Check for stored consent
    const storedConsent = localStorage.getItem('analytics-consent');
    
    // Only initialize if consent has been explicitly granted
    if (storedConsent === 'true' || consentGranted) {
      ReactGA.initialize(MEASUREMENT_ID);
      isInitialized = true;
      console.log('Google Analytics initialized');
    }
  }
};

/**
 * Track page view
 * @param page - Page path to track
 */
export const pageview = (page: string) => {
  if (typeof window !== 'undefined' && isInitialized) {
    ReactGA.send({
      hitType: 'pageview',
      page,
    });
  }
};

/**
 * Track an event
 * @param category - Event category
 * @param action - Event action
 * @param label - Event label (optional)
 * @param value - Event value (optional)
 */
export const event = ({
  category,
  action,
  label,
  value,
}: {
  category: string;
  action: string;
  label?: string;
  value?: number;
}) => {
  if (typeof window !== 'undefined' && isInitialized) {
    ReactGA.event({
      category,
      action,
      label,
      value,
    });
  }
};